module.exports = __webpack_public_path__ + "static/img/dkwps2-10.81649f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-10.png
// module id = 674
// module chunks = 0